import { Divider } from '@/components/Divider'
import { FederalBallotSummary } from '@/domain/FederalBallotSummary'
import { OverrideableBallotState } from '@/domain/overrideable-ballot-state'
import * as React from 'react'
import { css } from 'styled-components/macro'
import TileBottom from './TileBottom'
import TileTop from './TileTop'

const Root = 'div'

interface Props extends React.ComponentPropsWithoutRef<typeof Root> {
  popularVoteId: string
  federalBallotId: string

  state: OverrideableBallotState
  summary: FederalBallotSummary
}

function Tile(props: Props) {
  const { popularVoteId, federalBallotId, state, summary, ...rest } = props

  return (
    <Root {...rest} css={styles.root as any}>
      <Divider variant="strong" />

      <div css={styles.top as any}>
        <TileTop state={state} summary={summary} />
      </div>

      <TileBottom
        css={styles.bottom as any}
        popularVoteId={popularVoteId}
        federalBallotId={federalBallotId}
        state={state}
        summary={summary}
      />

      <Divider />
    </Root>
  )
}

const styles = {
  root: css`
    display: flex;
    flex-direction: column;
  `,

  top: css`
    margin: 20px 0;
    overflow: hidden;
  `,
  bottom: css`
    margin-bottom: 20px;
  `,
}

export default Tile
